"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5153],{

/***/ 55153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20558);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





const Description = (props)=>{
    const { linkURL ="" , linkURLRef ="" , linkNewTab ="" , description ="" , mainTitle ="" , componentPosition =null , componentLinkType =null , pageType: serverPageType = "" , linkDescription =false , general ={} , expandText ="" , collapseText ="" , disableExpandCollapse =""  } = props;
    const [shortenedLinkUrl, setShortenedLinkUrl] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [pageType, setPageType] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(serverPageType);
    const [target, setTarget] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [details, setDetails] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(description);
    const [isPdp, setIsPdp] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        window.expandText = expandText;
        window.collapseText = collapseText;
        window.disableExpandCollapse = disableExpandCollapse;
    }, [
        expandText,
        collapseText,
        disableExpandCollapse
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        var ref, ref1, ref2;
        const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
        if (serverPageType !== (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp") {
            var ref3;
            setPageType(pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref3 = pageInfoDetails.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.contentType);
            setIsPdp(true);
        }
    }, []);
    const internalLinkPositionNotPdp = "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser");
    const internalLinkTypeNotPdp = "".concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase());
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(general)) {
            if (linkURL) {
                setShortenedLinkUrl((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.getShortenedUrlwithGeneral)(linkURL, general));
            }
            if (description) {
                setDetails((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.getShortenedUrlwithGeneral)(description, general));
            }
        }
    }, [
        linkURL,
        description,
        general
    ]);
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (linkNewTab) {
            setTarget("_blank");
        } else {
            setTarget("_self");
        }
    }, [
        linkNewTab
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "cmp-teaser__description",
        "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(target === "_blank" ? "false" : "true", '","internalLinkPosition": "').concat(isPdp ? pageType.toLowerCase() : internalLinkPositionNotPdp, '","internalLinkZoneName": "').concat(mainTitle ? "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(mainTitle) : "teaser", '","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.sanitizeTextArticle)(description.toLowerCase()), '","eventName":"').concat(pageType.toLowerCase(), ":").concat(mainTitle, ':rm","internalLinkType":"').concat(isPdp ? "".concat(pageType.toLowerCase(), ":teaser") : internalLinkTypeNotPdp, '","eventType": "').concat(isPdp ? "navigation" : "teaser", '","eventMsg":"n/a","eventStatus":"n/a","eventAction":"').concat(pageType.toLowerCase(), ":").concat(mainTitle, ':rm"}'),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_index__WEBPACK_IMPORTED_MODULE_2__.ConditionalWrapper, {
            condition: linkDescription,
            wrapper: (children)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: shortenedLinkUrl,
                    rel: linkURLRef ? "noreferrer" : "",
                    target: target,
                    children: children
                }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__.sanitizeInnerHtml)(details)
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Description);


/***/ })

}]);